export class ArrayUtils {
  public static sortArrayByField(array = [], field: string) {
    array.sort(function (a, b) {
      const textA = a[field].toUpperCase();
      const textB = b[field].toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    return array;
  }
}
